import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../pages/Login.vue'
import Wiki from '../pages/Wiki.vue'
import Invoice from '../pages/Invoice.vue'
import firebase from 'firebase/app'
import 'firebase/auth'
import SetInterval from '@/plugins/SetInterval'

Vue.use(VueRouter)
Vue.use(SetInterval)

const routes = [
  {
    path: '/',
    redirect: '/wiki/f9b97452727c40e1a1a2fad4606a25fb'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { beforeLogin: true }
  },
  {
    path: '/wiki/:id',
    name: 'Wiki',
    component: Wiki,
    meta: { requiresAuth: true }
  },
  {
    path: '/invoice',
    name: 'Invoice',
    component: Invoice,
    meta: { requiresAuth: true }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.name == 'Login') {
    firebase.auth().onAuthStateChanged(function (user) {
      if (user && localStorage.getItem('token')) {
        next({
          path: '/',
          query: { redirect: to.fullPath }
        })
      } else {
        next()
      }
    })
  } else {
    firebase.auth().onAuthStateChanged(function (user) {
      if (user && localStorage.getItem('token')) {
        next()
      } else {
        next({
          path: '/login',
          query: { redirect: to.fullPath }
        })
      }
    })
  }
})

export default router
